require('./bootstrap');


//require jquery
global.$ = global.jQuery = require('jquery');


